
import { Variant } from "../Variant.js";
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, record_type, lambda_type, class_type, int32_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { IconChevronLeft, IconMail, IconArrowRight, IconPackage, IconPhone, IconCalendar } from "../Components/Icon.js";
import { createElement } from "react";
import React from "react";
import { reactElement, reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { isNullOrWhiteSpace, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { SupportMessageDto, SupportMessageResponse_$reflection, SupportMessageDto_$reflection } from "../Shared/Support.js";
import { FormState__startLoading, FormState_get_empty, PostResponse$1_$reflection, FormState_$reflection } from "../Shared/Shared.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../Communication.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast } from "../Components/Toast.js";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { mapIndexed } from "../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";

const accent = "#15B897";

const accentSoft = "#E4F7F2";

const accentInk = "#0B7A65";

const textMuted = "#6B7280";

const textSubtle = "#98A0A8";

const borderColor = "#E6E8EB";

const surface = "#FFFFFF";

const demoBookingUrl = (Variant.tag === 1) ? "https://meet.inventory-one.com/meetings/christoph61/terminvereinbarung-inventory-one" : "https://meet.inventory-one.com/meetings/christoph61/terminplanung-meinwerkzeugkoffer";

class Section extends Record {
    constructor(Title, Desc, Icon) {
        super();
        this.Title = Title;
        this.Desc = Desc;
        this.Icon = Icon;
    }
}

function Section_$reflection() {
    return record_type("OnboardingHub.ContactGuide.Section", [], Section, () => [["Title", string_type], ["Desc", string_type], ["Icon", lambda_type(int32_type, class_type("Fable.React.ReactElement"))]]);
}

function sections(t) {
    return [new Section(t("onboarding.contact_guide.consultation_title"), t("onboarding.contact_guide.consultation_desc"), IconCalendar), new Section(t("onboarding.contact_guide.contact_title"), t("onboarding.contact_guide.contact_desc"), IconPhone), new Section(t("onboarding.contact_guide.package_title"), t("onboarding.contact_guide.package_desc"), IconPackage)];
}

function SectionItem(props) {
    let elems_2, elems, elems_1;
    const patternInput = reactApi.useState(false);
    const setHovered = patternInput[1];
    return reactElement("button", createObj(ofArray([["onMouseEnter", (_arg) => {
        setHovered(true);
    }], ["onMouseLeave", (_arg_1) => {
        setHovered(false);
    }], ["onClick", (_arg_2) => {
        props.OnClick();
    }], ["style", {
        display: "flex",
        alignItems: "flex-start",
        gap: 14 + "px ",
        padding: ((14 + "px ") + 16) + "px",
        borderRadius: 10,
        textAlign: "left",
        cursor: "pointer",
        width: 100 + "%",
        backgroundColor: props.IsActive ? accentSoft : (patternInput[0] ? "#F9FAFB" : "transparent"),
        border: props.IsActive ? concat("1px solid ", ...accent) : "1px solid transparent",
        transition: "all 0.15s ease",
    }], (elems_2 = [reactElement("div", createObj(ofArray([["style", {
        width: 36,
        height: 36,
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        backgroundColor: props.IsActive ? accent : "#F3F4F6",
        color: props.IsActive ? surface : textMuted,
    }], (elems = [props.Section.Icon(16)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(singleton((elems_1 = [reactElement("div", {
        style: {
            fontWeight: 600,
            fontSize: 14 + "px",
            color: "#14181B",
            marginBottom: 2,
        },
        children: props.Section.Title,
    }), reactElement("p", {
        style: {
            fontSize: 12 + "px",
            color: textMuted,
            margin: 0,
            lineHeight: 1.4,
        },
        children: props.Section.Desc,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function consultationContent(t) {
    let elems_7, elems_5, elems_4, elems_1, elems, elems_3, elems_2, elems_6;
    return reactElement("div", createObj(ofArray([["style", {
        padding: ((40 + "px ") + 40) + "px",
    }], (elems_7 = [reactElement("h2", {
        style: {
            fontSize: 22 + "px",
            fontWeight: 600,
            margin: ((((((0 + "px ") + 0) + "px ") + 8) + "px ") + 0) + "px",
            color: "#14181B",
        },
        children: t("onboarding.contact_guide.consultation_heading"),
    }), reactElement("p", {
        style: {
            fontSize: 14 + "px",
            color: textMuted,
            lineHeight: 1.6,
            margin: ((((((0 + "px ") + 0) + "px ") + 32) + "px ") + 0) + "px",
        },
        children: t("onboarding.contact_guide.consultation_body"),
    }), reactElement("div", createObj(ofArray([["style", {
        backgroundColor: accentSoft,
        border: concat("1px solid ", ...accent),
        borderRadius: 10,
        padding: ((20 + "px ") + 24) + "px",
        marginBottom: 32,
    }], (elems_5 = [reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px ",
    }], (elems_4 = [reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
    }], (elems_1 = [reactElement("div", createObj(ofArray([["style", {
        color: accentInk,
    }], (elems = [IconCalendar(16)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("span", {
        style: {
            fontSize: 13 + "px",
            color: "#14181B",
            fontWeight: 500,
        },
        children: t("onboarding.contact_guide.consultation_bullet_1"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
    }], (elems_3 = [reactElement("div", createObj(ofArray([["style", {
        color: accentInk,
    }], (elems_2 = [IconPhone(16)], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("span", {
        style: {
            fontSize: 13 + "px",
            color: "#14181B",
            fontWeight: 500,
        },
        children: t("onboarding.contact_guide.consultation_bullet_2"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), reactElement("button", createObj(ofArray([["onClick", (_arg) => {
        window.open(demoBookingUrl, "_blank");
    }], ["style", {
        display: "flex",
        alignItems: "center",
        gap: 8 + "px ",
        padding: ((14 + "px ") + 20) + "px",
        backgroundColor: accent,
        color: surface,
        borderRadius: 10,
        cursor: "pointer",
        fontWeight: 600,
        fontSize: 14 + "px",
        border: "none",
        transition: "background 0.15s ease",
    }], (elems_6 = [reactElement("span", {
        children: t("onboarding.contact_guide.consultation_cta"),
    }), IconArrowRight(16)], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), reactElement("p", {
        style: {
            fontSize: 12 + "px",
            color: textSubtle,
            marginTop: 10,
        },
        children: t("onboarding.contact_guide.consultation_hint"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

class ContactFormState extends Record {
    constructor(Dto, FormState) {
        super();
        this.Dto = Dto;
        this.FormState = FormState;
    }
}

function ContactFormState_$reflection() {
    return record_type("OnboardingHub.ContactGuide.ContactFormState", [], ContactFormState, () => [["Dto", SupportMessageDto_$reflection()], ["FormState", FormState_$reflection()]]);
}

class ContactFormMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetMessage", "SetPhoneNumber", "SendMessage", "SendResponse", "FetchError"];
    }
}

function ContactFormMsg_$reflection() {
    return union_type("OnboardingHub.ContactGuide.ContactFormMsg", [], ContactFormMsg, () => [[["Item", string_type]], [["Item", string_type]], [], [["Item", PostResponse$1_$reflection(SupportMessageResponse_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

function contactFormInit() {
    return [new ContactFormState(new SupportMessageDto("", ""), FormState_get_empty()), Cmd_none()];
}

function contactFormUpdate(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new ContactFormState(new SupportMessageDto(msg.fields[0], state.Dto.Message), state.FormState), Cmd_none()];
        case 2:
            return [new ContactFormState(state.Dto, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(tupledArg[0]), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(SupportMessageResponse_$reflection())));
            })))), ["/api/support/message", toString(0, Auto_generateBoxedEncoder_437914C6(SupportMessageDto_$reflection(), undefined, undefined, undefined)(state.Dto))], (Item) => (new ContactFormMsg(3, [Item])), (Item_1) => (new ContactFormMsg(4, [Item_1])))];
        case 3:
            return [new ContactFormState(new SupportMessageDto("", ""), FormState_get_empty()), Cmd_successToast("support.message_sent")];
        case 4:
            return [new ContactFormState(state.Dto, FormState_get_empty()), Cmd_none()];
        default:
            return [new ContactFormState(new SupportMessageDto(state.Dto.PhoneNumber, msg.fields[0]), state.FormState), Cmd_none()];
    }
}

function ContactForm(props) {
    let elems_9, elems_6, elems_2, elems, elems_1, elems_5, elems_3, elems_4, elems_8, elems_7;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(contactFormInit, contactFormUpdate, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const isLoading = state_1.FormState.IsLoading;
    const canSend = !isNullOrWhiteSpace(state_1.Dto.Message);
    return reactElement("div", createObj(ofArray([["style", {
        padding: ((40 + "px ") + 40) + "px",
    }], (elems_9 = [reactElement("h2", {
        style: {
            fontSize: 22 + "px",
            fontWeight: 600,
            margin: ((((((0 + "px ") + 0) + "px ") + 8) + "px ") + 0) + "px",
            color: "#14181B",
        },
        children: t("onboarding.contact_guide.contact_heading"),
    }), reactElement("p", {
        style: {
            fontSize: 14 + "px",
            color: textMuted,
            lineHeight: 1.6,
            margin: ((((((0 + "px ") + 0) + "px ") + 28) + "px ") + 0) + "px",
        },
        children: t("onboarding.contact_guide.contact_body"),
    }), reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 12 + "px ",
        marginBottom: 32,
    }], (elems_6 = [reactElement("a", createObj(ofArray([["href", concat("tel:", ...props.PhoneNumber)], ["style", {
        display: "flex",
        alignItems: "center",
        gap: 14 + "px ",
        padding: ((16 + "px ") + 20) + "px",
        backgroundColor: "#F9FAFB",
        border: concat("1px solid ", ...borderColor),
        borderRadius: 10,
        "text-decoration": "none",
        color: "#14181B",
    }], (elems_2 = [reactElement("div", createObj(ofArray([["style", {
        width: 36,
        height: 36,
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: accentSoft,
        color: accentInk,
    }], (elems = [IconPhone(16)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(singleton((elems_1 = [reactElement("div", {
        style: {
            fontSize: 11 + "px",
            color: textSubtle,
            marginBottom: 2,
        },
        children: t("onboarding.contact_guide.contact_phone_label"),
    }), reactElement("div", {
        style: {
            fontSize: 14 + "px",
            fontWeight: 600,
        },
        children: props.PhoneNumber,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("a", createObj(ofArray([["href", concat("mailto:", ...props.Email)], ["style", {
        display: "flex",
        alignItems: "center",
        gap: 14 + "px ",
        padding: ((16 + "px ") + 20) + "px",
        backgroundColor: "#F9FAFB",
        border: concat("1px solid ", ...borderColor),
        borderRadius: 10,
        "text-decoration": "none",
        color: "#14181B",
    }], (elems_5 = [reactElement("div", createObj(ofArray([["style", {
        width: 36,
        height: 36,
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: accentSoft,
        color: accentInk,
    }], (elems_3 = [IconMail(16)], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("div", createObj(singleton((elems_4 = [reactElement("div", {
        style: {
            fontSize: 11 + "px",
            color: textSubtle,
            marginBottom: 2,
        },
        children: t("onboarding.contact_guide.contact_email_label"),
    }), reactElement("div", {
        style: {
            fontSize: 14 + "px",
            fontWeight: 600,
        },
        children: props.Email,
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))]))))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 8 + "px ",
    }], (elems_8 = [reactElement("label", {
        style: {
            fontSize: 13 + "px",
            fontWeight: 500,
            color: "#14181B",
        },
        children: t("onboarding.contact_guide.contact_message_label"),
    }), reactElement("textarea", {
        value: state_1.Dto.Message,
        onChange: (ev) => {
            dispatch(new ContactFormMsg(0, [ev.target.value]));
        },
        placeholder: t("onboarding.contact_guide.contact_message_placeholder"),
        rows: 4,
        disabled: isLoading,
        style: {
            width: 100 + "%",
            padding: ((12 + "px ") + 14) + "px",
            borderRadius: 8,
            border: concat("1px solid ", ...borderColor),
            fontSize: 14 + "px",
            color: "#14181B",
            resize: "vertical",
            outline: "none",
            "font-family": "inherit",
        },
    }), reactElement("input", {
        value: state_1.Dto.PhoneNumber,
        onChange: (ev_1) => {
            dispatch(new ContactFormMsg(1, [ev_1.target.value]));
        },
        placeholder: t("onboarding.contact_guide.contact_phone_placeholder"),
        disabled: isLoading,
        style: {
            width: 100 + "%",
            padding: ((10 + "px ") + 14) + "px",
            borderRadius: 8,
            border: concat("1px solid ", ...borderColor),
            fontSize: 14 + "px",
            color: "#14181B",
            outline: "none",
            "font-family": "inherit",
        },
    }), reactElement("button", createObj(ofArray([["onClick", (_arg_2) => {
        if (canSend && !isLoading) {
            dispatch(new ContactFormMsg(2, []));
        }
    }], ["disabled", !canSend ? true : isLoading], ["style", {
        display: "flex",
        alignItems: "center",
        gap: 8 + "px ",
        padding: ((12 + "px ") + 20) + "px",
        backgroundColor: (canSend && !isLoading) ? accent : "#D1D5DB",
        color: surface,
        borderRadius: 8,
        cursor: (canSend && !isLoading) ? "pointer" : "default",
        fontWeight: 600,
        fontSize: 14 + "px",
        border: "none",
        alignSelf: "flex-start",
        transition: "background 0.15s ease",
    }], (elems_7 = [reactElement("span", {
        children: [isLoading ? t("onboarding.contact_guide.contact_sending") : t("onboarding.contact_guide.contact_send")],
    })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
}

function PackageForm() {
    let elems_1, elems;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(contactFormInit, contactFormUpdate, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const isLoading = state_1.FormState.IsLoading;
    const canSend = !isNullOrWhiteSpace(state_1.Dto.Message);
    return reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 8 + "px ",
    }], (elems_1 = [reactElement("label", {
        style: {
            fontSize: 13 + "px",
            fontWeight: 500,
            color: "#14181B",
        },
        children: t("onboarding.contact_guide.contact_message_label"),
    }), reactElement("textarea", {
        value: state_1.Dto.Message,
        onChange: (ev) => {
            dispatch(new ContactFormMsg(0, [ev.target.value]));
        },
        placeholder: t("onboarding.contact_guide.package_message_placeholder"),
        rows: 4,
        disabled: isLoading,
        style: {
            width: 100 + "%",
            padding: ((12 + "px ") + 14) + "px",
            borderRadius: 8,
            border: concat("1px solid ", ...borderColor),
            fontSize: 14 + "px",
            color: "#14181B",
            resize: "vertical",
            outline: "none",
            "font-family": "inherit",
        },
    }), reactElement("input", {
        value: state_1.Dto.PhoneNumber,
        onChange: (ev_1) => {
            dispatch(new ContactFormMsg(1, [ev_1.target.value]));
        },
        placeholder: t("onboarding.contact_guide.contact_phone_placeholder"),
        disabled: isLoading,
        style: {
            width: 100 + "%",
            padding: ((10 + "px ") + 14) + "px",
            borderRadius: 8,
            border: concat("1px solid ", ...borderColor),
            fontSize: 14 + "px",
            color: "#14181B",
            outline: "none",
            "font-family": "inherit",
        },
    }), reactElement("button", createObj(ofArray([["onClick", (_arg_2) => {
        if (canSend && !isLoading) {
            dispatch(new ContactFormMsg(2, []));
        }
    }], ["disabled", !canSend ? true : isLoading], ["style", {
        display: "flex",
        alignItems: "center",
        gap: 8 + "px ",
        padding: ((12 + "px ") + 20) + "px",
        backgroundColor: (canSend && !isLoading) ? accent : "#D1D5DB",
        color: surface,
        borderRadius: 8,
        cursor: (canSend && !isLoading) ? "pointer" : "default",
        fontWeight: 600,
        fontSize: 14 + "px",
        border: "none",
        alignSelf: "flex-start",
        transition: "background 0.15s ease",
    }], (elems = [reactElement("span", {
        children: [isLoading ? t("onboarding.contact_guide.contact_sending") : t("onboarding.contact_guide.package_send")],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function packageContent(t) {
    let elems_2, elems, elems_1;
    return reactElement("div", createObj(ofArray([["style", {
        padding: ((40 + "px ") + 40) + "px",
    }], (elems_2 = [reactElement("h2", {
        style: {
            fontSize: 22 + "px",
            fontWeight: 600,
            margin: ((((((0 + "px ") + 0) + "px ") + 8) + "px ") + 0) + "px",
            color: "#14181B",
        },
        children: t("onboarding.contact_guide.package_heading"),
    }), reactElement("p", {
        style: {
            fontSize: 14 + "px",
            color: textMuted,
            lineHeight: 1.6,
            margin: ((((((0 + "px ") + 0) + "px ") + 28) + "px ") + 0) + "px",
        },
        children: t("onboarding.contact_guide.package_body"),
    }), reactElement("button", createObj(ofArray([["onClick", (_arg) => {
        window.open(demoBookingUrl, "_blank");
    }], ["style", {
        display: "flex",
        alignItems: "center",
        gap: 8 + "px ",
        padding: ((14 + "px ") + 20) + "px",
        backgroundColor: accent,
        color: surface,
        borderRadius: 10,
        cursor: "pointer",
        fontWeight: 600,
        fontSize: 14 + "px",
        border: "none",
    }], (elems = [reactElement("span", {
        children: [t("onboarding.contact_guide.package_cta")],
    }), IconArrowRight(16)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 12 + "px ",
        margin: ((24 + "px ") + 0) + "px",
    }], (elems_1 = [reactElement("div", {
        style: {
            flexGrow: 1,
            height: 1,
            backgroundColor: borderColor,
        },
    }), reactElement("span", {
        style: {
            fontSize: 12 + "px",
            color: textSubtle,
            flexShrink: 0,
        },
        children: t("onboarding.contact_guide.package_divider"),
    }), reactElement("div", {
        style: {
            flexGrow: 1,
            height: 1,
            backgroundColor: borderColor,
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(PackageForm, null)], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function ContactPanels() {
    let elems_2, elems, elems_1;
    const t = useTranslation()[0];
    const phoneNumber = t("global.phone_number");
    const email = t("global.support_email");
    const patternInput_1 = reactApi.useState(0);
    const activeSection = patternInput_1[0] | 0;
    return reactElement("div", createObj(ofArray([["style", {
        display: "grid",
        "grid-template-columns": "340px 1fr",
        gap: 24 + "px ",
        alignItems: "flex-start",
    }], (elems_2 = [reactElement("div", createObj(ofArray([["style", {
        backgroundColor: surface,
        border: concat("1px solid ", ...borderColor),
        borderRadius: 14,
        padding: ((8 + "px ") + 8) + "px",
        display: "flex",
        flexDirection: "column",
        gap: 4 + "px ",
    }], (elems = toList(delay(() => append(singleton_1(reactElement("h3", {
        style: {
            fontSize: 11 + "px",
            fontWeight: 600,
            color: textSubtle,
            margin: ((((((8 + "px ") + 12) + "px ") + 4) + "px ") + 12) + "px",
            textTransform: "uppercase",
            "letter-spacing": "0.07em",
        },
        children: t("onboarding.contact_guide.sidebar_label"),
    })), delay(() => ofArray(mapIndexed((i, section) => createElement(SectionItem, {
        IsActive: activeSection === i,
        OnClick: () => {
            patternInput_1[1](i);
        },
        Section: section,
    }), sections(t))))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["style", {
        backgroundColor: surface,
        border: concat("1px solid ", ...borderColor),
        borderRadius: 14,
        overflow: "hidden",
        minHeight: 400,
    }], (elems_1 = toList(delay(() => ((activeSection === 0) ? singleton_1(consultationContent(t)) : ((activeSection === 1) ? singleton_1(createElement(ContactForm, {
        Email: email,
        PhoneNumber: phoneNumber,
    })) : singleton_1(packageContent(t)))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function ContactGuideView(props) {
    let elems_2, elems_1, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["style", {
        maxWidth: 1180,
        margin: (0 + "px ") + "auto",
        paddingTop: 28,
    }], (elems_2 = [reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
        marginBottom: 32,
    }], (elems_1 = [reactElement("button", createObj(ofArray([["onClick", (_arg) => {
        props.OnBack();
    }], ["style", {
        display: "flex",
        alignItems: "center",
        gap: 6 + "px ",
        fontSize: 13 + "px",
        color: textMuted,
        cursor: "pointer",
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
    }], (elems = [IconChevronLeft(14), t("onboarding.contact_guide.back")], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("span", {
        style: {
            color: borderColor,
        },
        children: "/",
    }), reactElement("h1", {
        style: {
            fontSize: 22 + "px",
            fontWeight: 600,
            margin: 0,
            color: "#14181B",
        },
        children: t("onboarding.contact_guide.title"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(ContactPanels, null)], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

